import React from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {TextField} from '@material-ui/core';

const AutocompleteMultiple = ({
  options,
  changeValue,
  label,
  customOptionLabel,
  customOptionSelected,
  defaultValue,
  error,
  helperText,
}) => {
  return (
    <Autocomplete
      multiple
      id="tags-standard"
      value={defaultValue}
      options={options.data ? options.data : options}
      getOptionLabel={
        customOptionLabel
          ? customOptionLabel
          : (option) =>
              typeof option === 'object' ? `${option.title}` : option
      }
      getOptionSelected={
        customOptionSelected
          ? customOptionSelected
          : (option, value) => {
              return typeof option === 'object'
                ? option.id === value.id
                : option === value;
            }
      }
      onChange={(_, value) => {
        if (value !== null) {
          changeValue(value);
        } else {
          changeValue('');
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label={label}
          error={error}
          helperText={helperText}
        />
      )}
    />
  );
};

export default AutocompleteMultiple;
